// @flow

import * as React from "react"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"

import Config from "../../config"
import {
  setShop,
  setShopItems,
  setShopSearchItems,
  generateShop,
  createShopItem,
  generateShopTips,
} from "../../actions/shop"
import {getSelectSearchItemIds, getSearchItemByKey} from "../../reducers/shop"
import type {
  Dispatch,
  State as ReduxState,
  ShopItem,
  ShopItemType,
  SearchItem,
  Shop,
} from "../../types"

import ShopAdminSearchItemList from "../../components/shop/admin/search-item-list"
import ShopAdminItemList from "../../components/shop/admin/item-list"
import ShopAdminComposeActions from "../../components/shop/admin/compose-actions"
import ShopAdminItemListActions from "../../components/shop/admin/item-list-actions"
import ShopAdminSettingsModal from "../../components/modals/shop-admin-settings"
import ShopAdminShopProductsModal from "../../components/modals/shop-admin-shop-products"

type Props = {
  +t: any,
  +babyToken: string,
  +shop: Shop,
  +dispatch: Dispatch,
  +shopItems: $ReadOnlyArray<ShopItem>,
  +searchItems: $ReadOnlyArray<SearchItem>,
  +selectedSearchItems: $ReadOnlyArray<string>,
}

type State = {
  +isDIY: boolean,
  +isSettingsModalOpen: boolean,
  +isShopProductsModalOpen: boolean,
}

class ShopAdminView extends React.Component<Props, State> {
  handleGenerateClick: () => void
  handleDIYClick: () => void
  handleAddShopItem: (ShopItemType) => void
  handleAddShopProducts: () => void

  handleShopSettings: () => void
  handleCloseSettingsModal: () => void
  handleCloseShopProductsModal: () => void

  constructor(props: Props) {
    super(props)

    this.state = {
      isDIY: false,
      isSettingsModalOpen: false,
      isShopProductsModalOpen: false,
    }

    this.handleGenerateClick = this.handleGenerateClick.bind(this)
    this.handleDIYClick = this.handleDIYClick.bind(this)
    this.handleAddShopItem = this.handleAddShopItem.bind(this)
    this.handleAddShopProducts = this.handleAddShopProducts.bind(this)

    this.handleShopSettings = this.handleShopSettings.bind(this)
    this.handleCloseSettingsModal = this.handleCloseSettingsModal.bind(this)
    this.handleCloseShopProductsModal =
      this.handleCloseShopProductsModal.bind(this)
  }

  componentDidMount() {
    // for dashboard views, the base entities are already output in the html
    this.props.dispatch(setShop(Config.data.shop.shop))
    this.props.dispatch(setShopItems(Config.data.shop.shopItems))
    this.props.dispatch(setShopSearchItems(Config.data.shop.searchItems))
  }

  handleShopSettings() {
    this.setState({isSettingsModalOpen: true})
  }

  handleCloseSettingsModal() {
    this.setState({isSettingsModalOpen: false})
  }

  handleCloseShopProductsModal() {
    this.setState({isShopProductsModalOpen: false})
  }

  handleGenerateClick() {
    const {dispatch, babyToken} = this.props
    dispatch(generateShop(babyToken))
    dispatch(generateShopTips(babyToken))
  }

  handleDIYClick() {
    const {dispatch, babyToken} = this.props
    this.setState({isDIY: true})
    dispatch(generateShopTips(babyToken))
  }

  handleAddShopItem(type: ShopItemType) {
    const {dispatch, selectedSearchItems, searchItems} = this.props
    const babyListItemIds = getSelectSearchItemIds(
      selectedSearchItems,
      searchItems
    )
    dispatch(createShopItem(Config.data.babyToken, type, babyListItemIds))
  }

  handleAddShopProducts() {
    const {selectedSearchItems, searchItems} = this.props
    const searchItem = getSearchItemByKey(selectedSearchItems[0], searchItems)
    if (searchItem) {
      this.setState({isShopProductsModalOpen: true})
    }
  }

  renderBrandNew() {
    const {t} = this.props
    return (
      <div className="d-flex align-items-center justify-content-center">
        <div className="panel">
          <h3>{t("shopAdmin.new.title")}</h3>
          <button
            className="btn btn-success"
            type="button"
            onClick={this.handleGenerateClick}
          >
            {t("shopAdmin.new.cta")}
          </button>
          <a
            href="#"
            className="d-block mt-3 text-gray"
            onClick={this.handleDIYClick}
          >
            <small>{t("shopAdmin.new.diy")}</small>
          </a>
        </div>
      </div>
    )
  }

  renderStarted() {
    const {shopItems, shop, searchItems} = this.props
    const {t} = this.props

    const zeroItems = shopItems.filter(
      ({priceSelling, nameNl}) =>
        priceSelling == "0" && !["Kraamkost"].includes(nameNl)
    )
    const showZeroWarning = zeroItems.length > 0

    return (
      <div className="row">
        <div className="col-lg-12 col-xl-10">
          <div className="row mb-4">
            <div className="col-lg-8">
              <ShopAdminComposeActions
                onSingle={() => this.handleAddShopItem("single")}
                onMulti={() => this.handleAddShopItem("multi")}
                onGroup={() => this.handleAddShopItem("group")}
                onShopProduct={() => this.handleAddShopProducts()}
              />
            </div>
            <div className="col-lg-4 d-flex justify-content-end align-items-center">
              {shop.isClosed && <span className="">🔒</span>}
              <button
                className="btn btn-outline-primary"
                onClick={this.handleShopSettings}
              >
                {t("shopAdmin.editSettingsShopAdmin")}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              {searchItems.length > 0 ? (
                <>
                  <button
                    className="btn btn-success mb-4"
                    type="button"
                    onClick={this.handleGenerateClick}
                  >
                    {t("shopAdmin.new.cta")}
                  </button>
                  <div className="panel">
                    <ShopAdminSearchItemList items={searchItems} />
                  </div>
                </>
              ) : null}
            </div>
            <div className="col-md-8 mb-4">
              <ShopAdminItemListActions />
              {showZeroWarning ? (
                <div className="alert alert-warning" role="alert">
                  Je hebt producten aan 0 EUR in de shop staan!
                </div>
              ) : null}
              <ShopAdminItemList items={shopItems} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderModal() {
    const {isSettingsModalOpen, isShopProductsModalOpen} = this.state
    const {selectedSearchItems} = this.props
    if (isSettingsModalOpen) {
      return <ShopAdminSettingsModal onClose={this.handleCloseSettingsModal} />
    }
    if (isShopProductsModalOpen && selectedSearchItems.length) {
      const {searchItems} = this.props
      const searchItem = getSearchItemByKey(selectedSearchItems[0], searchItems)
      return (
        <ShopAdminShopProductsModal
          searchItem={searchItem}
          onClose={this.handleCloseShopProductsModal}
        />
      )
    }
  }

  render() {
    return (
      <div className="container shop-admin mt-4">
        {/* shops have a cash item and charity item when in intake_done */}
        {this.props.shopItems.length < 3 && !this.state.isDIY
          ? this.renderBrandNew()
          : this.renderStarted()}
        {this.renderModal()}
      </div>
    )
  }
}
const mapStateToProps = (state: ReduxState) => ({
  shopItems: state.shop.shopItems,
  searchItems: state.shop.searchItems,
  selectedSearchItems: state.shop.selectedSearchItems,
  babyToken: Config.data.babyToken,
  shop: state.shop.shop,
})

export default withTranslation()(connect(mapStateToProps)(ShopAdminView))
